import React, { useEffect, useState } from 'react'

import axios from 'axios'

import { ApiCallPost } from '../../ApiCall/ApiCall'


function AddFirst( {code ,exitadd , naturaleza}) {

    const [value,setValue] = useState( "" )
    const [codigos,setCodigos] = useState( [] )
    const [nameCodigo,setNameCodigo] = useState( "") ;
    const [cero,setCero] = useState( "")

    const [nat,setNat] = useState( "A" )

    const [theNat,setTheNat] = useState( "")

    

    // useEffect(() => {

    //     console.log( "nat = " + nat ) ;
    // } ,[nat])

    useEffect(() => {


        setNat( naturaleza )
    } ,[naturaleza])


    useEffect(() => {

        var val = parseNaturaleza('A')

        console.log( "Val = " + val ) ;

        setTheNat( val )

    } , [value])



    function parseNaturaleza( nat )
    {
        nat = value ;
      /*
      100 Deudoras
      200 Acredoras
      300 Acredoras
      400 A/D  Todas son A , excepto 402 ( D )
      500 A/D ( 503 , 504 son A ) otras son deudoras
      600 Deudoras
      700 A/D  ( 701 D , 702 A , 703 D ,  704 A  )
      800 A/D  ( 801 , 802 , 803 , 804 ) Terminadoen en Non son D , y par es A
      */

      console.log( "Code??? = " + nat ) ;
  
      if ( nat.substring( 0 , 2 ) === '10' || nat.substring(0,2) === '60' )
      {
          return "D" ;
      }
  
      if ( nat.substring( 0 , 2 ) === '20' || nat.substring(0,2) === '30' )
      {
          return "A" ;
      }
  
      if ( nat.substring( 0 , 2 ) === '40')
      {
          if ( nat === '402')
          {
              return 'D' ;
          }
  
          return 'A' ;
      }
  
      if ( nat.substring( 0 , 2 ) === '50' )
      {
          if ( nat === '503' || nat === '504' )
          {
              return 'A' ;
          }
  
          return 'D' ;
  
      }
  
      if ( nat.substring( 0 ,2 ) === '70' )
      {
          if ( nat === '701' || nat === '703')
          {
              return 'D' ;
          }
  
          return 'A'
      }
  
  
      if ( nat.substring( 0 , 2) === '80' )
      {
          if ( nat === '801' || nat === '803')
          {
              return 'D' ;
          }
  
          return 'A' ;
      }
  
    }
  

    


    function handleGuardar()
    {

        var obj = {
            nivel :"1" ,
            parent : code ,
            second : value ,
            name : nameCodigo ,
            naturaleza : naturaleza ,
            tipo :"R" ,
            comment : document.getElementById("comentario").value ,
            dTimeStamp : getFormatDate( new Date() )
        }

        console.log( "handleGuardar =  " + JSON.stringify( obj ) ) ;


        ApiCallPost( "savesecond" , obj )
        .then((result) => {
            console.log( "result " + JSON.stringify( result ) ) ;
            return ;
        })
        .catch((err) => {
            console.log( err ) ;
        })


    }

    function getFormatDate(d) {
        var date = new Date(d);
        var dateStr =
            date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + date.getDate()).slice(-2) + " " +
            ("00" + date.getHours()).slice(-2) + ":" +
            ("00" + date.getMinutes()).slice(-2) + ":" +
            ("00" + date.getSeconds()).slice(-2);
        //console.log(dateStr);
    
        return dateStr;
    }
    

    function handleOnChange( val)
    {
        //console.log( "onChange val = " + JSON.stringify( val ) )

        var value = document.getElementById( "codigos").value ;

        console.log( "Value = " + value ) ;

        setValue( value ) ;

        for( var i = 0 ; i< codigos.length ; i++ )
        {
             if (  codigos[i].codigo === value )
             {

                setNameCodigo( codigos[i].nombre ) ;

                return  ; 

             }
        }


    }



    useEffect(() => {


        console.log( "useEffect code = " + code )

    axios.get(  "http://localhost:3004/livefactura/getGrupoFirst/?code=" + code )
    .then((response) => {
        console.log( "response(1) = " + JSON.stringify( response.data ) ) ;

        if ( response.data[0].length === 0 )
        {
            console.log( "No encontramos datos")
            return ;
        }

        console.log( "casegroup  = " + JSON.stringify( response.data[0].idcatcodigoagrupador ) ) ;


        if ( response.data.length > 0 )
        {
            //setShowDrop( true ) ;

            var arr = [] ;

            fillSelect( response.data ) ;

            for( var i = 0 ; i < response.data.length ; i++)
            {
                console.log( "Codigo = " + response.data[i].nombre ) ;

                var obj = {} ;
                obj.id = response.data[i].idcatcodigoagrupador  ; // idcasesatcodigo // idcasesatcodigo
                obj.field1 = response.data[i].codigo ;
                obj.field3 = response.data[i].nombre ;  
                obj.field2 = "Marketing Director" ;
                obj.field4 = "Hola" ; //response.data[i].comentario ;
                obj.field5 = "Creado por Charly" ;
                obj.field6 = "2024-02-11 17:01:02" ;   
                obj.naturaleza =  parseNaturaleza( response.data[i].naturaleza );  

                console.log( "Naturaleza *** " + response.data[i].naturaleza + " = "  + parseNaturaleza( response.data[i].nombre))

                if ( i === 0 )
                {
                    setValue(response.data[i].nombre   )
                }

                
                
                arr.push( obj ) ;

            }


            //setCards( arr ) ;

            setCodigos( response.data )

            setCero( response.data[0].nombre )

            handleOnChange( response.data[0].codigo)

        }
        else{
            //setShowDrop ( false ) ;
        }



    })
    .catch( (err) => {
        console.log( err) ;
    })

    }, [])


    useEffect(() =>{

        console.log( "useEffect")

        if( cero===undefined)
        {return ;}

        console.log( "cero = " + cero ) ;

        setNameCodigo( cero ) ;


    } ,[cero])


    function fillSelect(response)
    {
        var select = document.getElementById('codigos') ;

        while( select.length > 0 )
        {
            select.remove( select.length -1 ) ;
        }
    
        for( var i = 0 ; i < response.length ; i++)
        {
           
    
            var option = document.createElement("option");
            option.value = response[i].codigo;
            option.text =  response[i].codigo  ;

            select.appendChild(option)
    
        }

    }
    

  return (
    

<div className='box-login float-end' style={{ top:'15%' , 
        right:'35%' , backgroundColor :'lightgray' , borderRadius:'20px' ,  
        position : 'fixed' , zIndex : 200}} >

    <div className='d-flex flex-column align-items-center' 
        style={{borderWidth:2 , borderColor :'black' , fontFamily : 'Satoshi-Bold'}}>

        <div>
            <p className='tx-color-purple body-1 mt-2'>Código Primer Nivel</p>
        </div>

        <div className='display-label-none  w-100'>                    

            <form id='myForm form-2'  style={{color:'black'}}>
        
                <div className="form-outline m-4 mt-1 mb-1 " >
                    <label className="form-label" htmlFor="codigo" >Codigo</label>
                    <input readOnly type="text" id="codigo" value={code}
                    className="form-control" placeholder="Codigo" />
                    
                </div>


                <div className="form-group m-4 mt-1 mb-1">
                    <label for="codigos">Seleccione Código</label>
                    <select className="form-control" id="codigos" onChange={handleOnChange}>
                    <option>USD 100K - 125K</option>
                    
                    </select>
                </div>


                <div className="form-outline m-4 mt-1 mb-1 " >
                    <label className="form-label" htmlFor="codigo2" >Segundo Nivel</label>
                    <input value={value} readOnly type="text" id="codigo2" className="form-control" placeholder="Codigo2" />
                    
                </div>

                <div className="form-outline m-4 mt-1 mb-1 " >
                    <label className="form-label" htmlFor="nombre" >Nombre</label>
                    <input readOnly type="text" value={nameCodigo}
                    id="nombre" className="form-control" placeholder="Nombre" />
                    
                </div>


                <div className="form-outline m-4 mt-1 mb-1 " >
                    <label className="form-label" htmlFor="comentario" >Comentario</label>
                    <textarea  type="textarea" 
                    id="comentario" className="form-control" placeholder="Comentario" />
                    
                </div>


                {
                    ( theNat === "A" || theNat === "D" )&& (

                        <div className='m-4 mt-2 mb-1'>
                            <div className='row' >
                                <div className='col-4'>
                                    <p>Naturaleza</p>
                                </div>
                                <div className='col-4'>
                                    <p>{(theNat === "A" ? "Acredor" : "Deudor")}</p>
                                </div>
                            </div>
                        </div>
                    )
                }

                {/* {
                    naturaleza === "AD" && (

                        <div className='m-4 mt-1 mb-1'>

                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name='nat' 
                                    id="inlineCheckbox1" onChange={() => setNat('A')}
                                     value="option1" checked={(nat==='A')}/>
                                <label className="form-check-label" for="inlineCheckbox1">Acreedora</label>
                            </div>

                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name='nat' 
                                    id="inlineCheckbox2"  onChange={() => setNat('D')}
                                    value="option2" checked={(nat==='D')}/>
                                <label className="form-check-label" for="inlineCheckbox2">Deudora</label>
                            </div>

                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name='nat' 
                                    id="inlineCheckbox2"  onChange={() => setNat('AD')}
                                    value="option2" checked={(nat==='AD')}/>
                                <label className="form-check-label" for="inlineCheckbox2">AD</label>
                            </div>

                        
                        </div>
                    )

                }
 */}

                <div className='m-4 mt-2 mb-1'>
                    <div className='row' >
                        <div className='col-4 ' style={{textAlign:'left'}}>
                            <p >Tipo</p>
                        </div>
                        <div className='col-4'>
                            <p>Resumen</p>
                        </div>
                    </div>
                </div>






                <div className='row mt-0'>


                    <div className='col-5'>
                        <button type="button" onClick={handleGuardar} className="button-2  m-4">Guardar</button>
                    </div>
                    <div className='col-1'>

                    </div>
                    

                    <div className='col-4'>
                        <button type="button" onClick={exitadd} className="button-2 m-4">Salir</button>
                    </div>

                    <div className='col-2'>

                    </div>
                    
                </div>



            </form>
        </div>
    </div>
</div>

  )
}

export default AddFirst